declare global {
  type GtagFn = (command: string, targetIdOrEventName: string, params?: Record<string, unknown>) => void;

  interface Window {
    GA_MEASUREMENT_ID?: string;
    gtag?: GtagFn;
    dataLayer?: unknown[];
  }
}

export class SwupGA4 {
  private get GAID() {
    return window.GA_MEASUREMENT_ID ?? null;
  }
  private prevHref = document.referrer || location.href;

  constructor() {
    // ★ SPA では自動 page_view をオフ
    if (this.GAID && typeof window.gtag === "function") {
      window.gtag("config", this.GAID, { send_page_view: false });
    }
  }

  // swup の「ページ描画完了」イベントから呼ぶ
  public setSendPageView = () => {
    // タイトル更新が完了するまで 1〜2 フレーム待つ
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.sendPageView());
    });
  };

  private sendPageView = () => {
    if (!this.GAID || typeof window.gtag !== "function") return;

    const href = location.href;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: href,
      page_referrer: this.prevHref,
    });

    this.prevHref = href;
  };
}
